/**
 * Carousel Swiper Pattern - block editor & Cards
 *
 * LEGACY: Minimal safe guards added; slated for removal.
 */
document.addEventListener('DOMContentLoaded', function () {
	const carouselSwipers = Array.from(
		document.querySelectorAll('.carousel-swiper--pattern')
	).filter((carousel) => carousel.querySelector('.swiper-wrapper'));

	carouselSwipers.forEach((carousel) => {
		const wrapper = carousel.querySelector('.swiper-wrapper');
		if (!wrapper) {
			return;
		}

		// Add navigation buttons + pagination container
		const prevEl = document.createElement('button');
		prevEl.classList.add('swiper-button-prev');
		const nextEl = document.createElement('button');
		nextEl.classList.add('swiper-button-next');
		const scrollbar = document.createElement('div');
		//scrollbar.classList.add('swiper-scrollbar');
		scrollbar.classList.add('swiper-pagination');

		const parent = carousel;
		parent.appendChild(prevEl);
		parent.appendChild(nextEl);
		parent.appendChild(scrollbar);

		let breakPoints = false;
		let freeMode = true;
		let grabCursorSetting = true;
		let simulateTouchSetting = true;
		let loopSetting = false;
		let autoplaySetting = false;
		let paginationSetting = false;
		let scrollbarSetting = false;
		let slideClassName = 'wp-block-group'; // wp-block-cover, wp-block-post, etc.

		// Determine slide class + config based on wrapper classes
		if (wrapper.classList.contains('cards')) {
			slideClassName = 'card';
			breakPoints = { 960: { enabled: false } };
		} else if (wrapper.classList.contains('cover-slideshow')) {
			slideClassName = 'wp-block-cover';
			freeMode = false;
			grabCursorSetting = false;
			simulateTouchSetting = false;
		} else if (wrapper.classList.contains('wp-block-group')) {
			slideClassName = 'card-block';
			breakPoints = wrapper.classList.contains('mobile-carousel')
				? { 960: { enabled: false } }
				: { 960: { enabled: true } };
		} else if (wrapper.classList.contains('wp-block-post-template')) {
			slideClassName = 'wp-block-post';
			breakPoints = wrapper.classList.contains('mobile-carousel')
				? { 960: { enabled: false } }
				: { 960: { enabled: true } };
		} else if (wrapper.classList.contains('swiper-slideshow')) {
			slideClassName = 'wp-block-image';
			loopSetting = true;
			freeMode = false;
			autoplaySetting = {
				delay: 6000,
				disableOnInteraction: true,
			};
		} else if (wrapper.classList.contains('wp-block-gallery')) {
			slideClassName = 'wp-block-image';
		}

		const slides = wrapper.querySelectorAll('.' + slideClassName);
		const numberOfSlides = slides.length;

		// Pagination (fraction / bullets) decision
		if (wrapper.classList.contains('show-pagination')) {
			freeMode = false;
			scrollbarSetting = false;
			paginationSetting = {
				el: scrollbar,
				clickable: true,
				dynamicBullets: false,
			};
			if (wrapper.classList.contains('has-autoplay')) {
				paginationSetting = {
					el: scrollbar,
					clickable: true,
					dynamicBullets: false,
				};
			}
		}

		// Autoplay decision
		if (wrapper.classList.contains('has-autoplay')) {
			//loopSetting = true;
			loopSetting = numberOfSlides > 4 ? false : true;
			autoplaySetting = {
				delay: 6000,
				enabled: true,
				pauseOnMouseEnter: false,
				waitForTransition: false,
			};
		}

		const swiperSettings = {
			allowTouchMove: true,
			// autoplay: autoplaySetting,
			// breakpoints: breakPoints,
			centeredSlides: false,
			direction: 'horizontal',
			freeMode: freeMode,
			grabCursor: grabCursorSetting,
			keyboard: {
				enabled: true,
				onlyInViewport: true,
			},
			loop: loopSetting,
			mousewheel: {
				releaseOnEdges: true,
				forceToAxis: true,
			},
			navigation: {
				nextEl: nextEl,
				prevEl: prevEl,
			},
			on: {
				init() {
					if (this.slides.length <= 1) {
						// Skip when hidden: the slide count is unreliable inside a display:none ancestor
						if (
							this.pagination &&
							this.pagination.el &&
							carousel.offsetParent !== null
						) {
							this.pagination.el.remove();
						}

						if (this.navigation) {
							if (this.navigation.nextEl)
								this.navigation.nextEl.style.display = 'none';
							if (this.navigation.prevEl)
								this.navigation.prevEl.style.display = 'none';
						}
					}
				},
			},
			pagination: paginationSetting,
			scrollbar: scrollbarSetting,
			simulateTouch: simulateTouchSetting,
			slideClass: slideClassName,
			slidesPerView: 'auto',
			slidesPerGroup: 1, // make sure bullets match slides
			spaceBetween: 0,
			speed: 600,
		};
		// console.log('swiperSettings', swiperSettings);

		// Initialize Swiper
		const carouselSwiper = new Swiper(carousel, swiperSettings);
	});
});
